import cashBookInstance from '../../cashBook/instance'

const updateCategoryOfCashBook = (categoryId, data) => {
	return cashBookInstance.put(`/cash-book/categories/${categoryId}`, data)
}

export default updateCategoryOfCashBook
